module.exports = __webpack_public_path__ + "img/90sheji_linggan_13125030(1)@2x.20d644b5.png";